import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { cancelSubscription, getSubscriptionStatus, getCurrentRole } from "../api";

function dateLabel(value) {
  if (!value) return "See checkout for your billing date";
  const date = typeof value === "number"
    ? new Date(value * 1000)
    : new Date(value.replace(" ", "T") + "Z");
  return Number.isNaN(date.getTime()) ? "See checkout for your billing date" : date.toLocaleString();
}

export default function BillingPanel() {
  const [billing, setBilling] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  useEffect(() => {
    let mounted = true;
    getSubscriptionStatus().then((result) => { if (mounted) setBilling(result); })
      .catch((err) => { if (mounted) setError(err.message || "Unable to load billing details."); });
    return () => { mounted = false; };
  }, []);

  async function cancel() {
    if (!window.confirm("Schedule cancellation? Access continues until your current trial or billing period ends. There will be no renewal charge.")) return;
    setBusy(true); setError(""); setMessage("");
    try {
      const result = await cancelSubscription();
      setBilling(await getSubscriptionStatus());
      setMessage(result.message);
    } catch (err) { setError(err.message || "Unable to cancel. Contact support for help."); }
    finally { setBusy(false); }
  }
  const canManage = ["admin", "manager"].includes(getCurrentRole());
  return (
    <section aria-label="Billing" style={{ padding: 24, marginBottom: 28, border: "1px solid #d4af37", borderRadius: 14, background: "#fff", color: "#111827", overflowWrap: "anywhere" }}>
      <h2>Billing</h2>
      {error && <p role="alert" style={{ color: "#991b1b" }}>{error}</p>}
      {message && <p role="status">{message}</p>}
      {!billing && !error && <p>Loading billing details...</p>}
      {billing && <>
        <p>Plan: {(billing.subscription_plan || "Not selected").replace(/_/g, " ")}</p>
        <p>Status: {billing.subscription_status.replace(/_/g, " ")}</p>
        {billing.subscription_status === "trialing" && <p><strong>{billing.cancel_at_period_end ? "Trial access ends" : "Your first monthly charge is scheduled for"}: {dateLabel(billing.trial_end)}</strong></p>}
        {billing.subscription_status === "active" && billing.current_period_end && <p>{billing.cancel_at_period_end ? "Access ends" : "Next renewal"}: {dateLabel(billing.current_period_end)}</p>}
        {billing.cancel_at_period_end && <p>Cancellation is scheduled. Your subscription will not renew.</p>}
        {canManage && billing.has_subscription && !billing.cancel_at_period_end && !["canceled", "incomplete_expired"].includes(billing.subscription_status) && <button type="button" disabled={busy} onClick={cancel} style={{ padding: "12px 18px", borderRadius: 8, cursor: "pointer" }}>{busy ? "Scheduling cancellation..." : "Cancel subscription renewal"}</button>}
        {canManage && !billing.is_active && <p><Link to="/choose-plan">Choose a plan</Link></p>}
      </>}
      <p>Billing questions? <a href="mailto:support@integritysuitecrm.com">Contact support</a>.</p>
    </section>
  );
}

export function BillingPage() {
  const token = localStorage.getItem("token") || localStorage.getItem("access_token");
  if (!token) return <Navigate to="/login" replace />;
  return <main style={{ maxWidth: 900, margin: "40px auto", padding: 24 }}><p><Link to="/dashboard">Back to dashboard</Link></p><BillingPanel /></main>;
}
